// extracted by mini-css-extract-plugin
export default {"wrapper":"Token_wrapper__MzV-R","container":"Token_container__LJJBQ","title":"Token_title__3E1+R","table":"Token_table__NGFQZ","bottomContainer":"Token_bottomContainer__xwj6k"};